import { ButtonHTMLAttributes, RefObject } from "react";
import { selectStyle } from "Redux/appSlice";
import { useAppSelector } from "Redux/hooks";
function PrimaryButton({
  innerRef,
  children,
  ...props
}: ButtonHTMLAttributes<HTMLButtonElement> & {
  innerRef?: RefObject<HTMLButtonElement>;
}) {
  const { color2 } = useAppSelector(selectStyle);

  return (
    <button
      style={{ background: color2 }}
      type="button"
      className="inline-flex w-full justify-center rounded-3xl bg-primary px-6 py-2 text-lg font-semibold text-white shadow-sm transition-all hover:brightness-105 disabled:cursor-not-allowed disabled:opacity-50 sm:ml-3 sm:w-auto"
      ref={innerRef}
      {...props}
    >
      {children}
    </button>
  );
}

export default PrimaryButton;
